import React, {Component} from "react";
import SimpleFormBuilder from "../forms_builder/SimpleFormBuilder";
import utils from "../../utils/utils";
import Prototypes from "prop-types";
import {adminApi} from "../../services/ApiService";
import Constants from "../../utils/constants";
import * as Yup from "yup";
import validationHelper from "../../utils/validationHelper";
import {makeError} from "../modals/ErrorModal";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";
import {ConstantsArrT} from "../../utils/ConstantsWithTranslate";

class HcpEditForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {
                isClinicAdmin: false
            },
            matrix :[2,2,1,1,1,1,1],
            errors: {},
            errorsOnSave:{},
        };
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            First_name:Yup.string().required(t('admin.hcp.form.first_name_req')),
            Last_name:Yup.string().required(t('admin.hcp.form.last_name_req')),
            Profession:Yup.string().required('Profession is required'),
            Phone_num1:Yup.string().required(t('admin.hcp.form.phone_number_req')),
            Email:Yup.string().matches(Constants.emailRegExp, t('admin.hcp.form.email_invalid')).required(t('admin.hcp.form.email_req')),
            Clinic_ID:Yup.string().required(t('admin.hcp.form.clinic_req')),
            isClinicAdmin:Yup.boolean()
        })
        let errors = await validationHelper.validate(this.state.entry,validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        if (this.props && this.props.entry)
            await this.setState({entry:utils.removeEmptyOrNull(this.props.entry)})
        this.getClinicOptions()
        await this.initValidation()
    }

    async closeSideBar(){
        let {t} = this.props
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.hcp.form.withdraw_edit_hcp'),
            }},t('admin.hcp.form.withdraw_edit_hcp_info'))
        if (confirm) {
            this.props.closeSideBar(false)
            this.setState({entry:null})
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    async saveInfo(){
        let {t} = this.props
        let {entry} = this.state
        if (!utils.isEmpty(this.state.errors)){
            this.setState({errorsOnSave:this.state.errors});
            await makeError({
                proceedLabel: t('admin.hcp.form.ok'),
                options:{
                    title: t('admin.hcp.form.hcp_not_edited'),
                }
            },[t('admin.hcp.form.fill_all_req')]);
            return;
        }
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.hcp.form.edit_hcp'),
            }},`${t('admin.hcp.form.confirm_edit_hcp')}?`)
        if (confirm) {
            entry = utils.ObjectEmptiesToNulls(entry)
            let response = await adminApi.EditHCP(entry,entry.UserStorageID)
            if (response) {
                utils.set(entry,'FullName', entry.First_name + ' ' + entry.Last_name,)
                document.body.style.overflow = "auto"
                this.props.closeSideBar(false)
                this.props.editHCP(response.data)
                this.setState({entry:null})
            }
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    onEntryChange = async event => {
        let {entry,validationSchema} = this.state
        let name = event.target.name
        // let isNumeric = this.getFields().find(input => input.name === name).isNumeric
        let value = event.target.type === 'checkbox' ?
            !entry[name]
            :/*isNumeric?utils.toNumeric(event.target.value):*/event.target.value
        utils.set(entry,name,value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave,name)){
            utils.set(errorsOnSave,name,utils.get(errors,name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    onEntryChangeByDropdown = async (name,value) => {
        let {entry,validationSchema} = this.state
        utils.set(entry,name,value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave,name)){
            utils.set(errorsOnSave,name,utils.get(errors,name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    getClinicOptions = async () => {
        let clinicOptions = []
        let clinics = await adminApi.getAllClinics()
        if (clinics && clinics.data.length > 0){
            clinics.data.forEach(clinic => {
                clinicOptions.push({label: clinic.Clinic_Name, value: clinic.Clinic_ID /*clinic.Clinic_ID*/})
            })
        }
        this.setState({clinicOptions})
    }

    getFields = () => {
        let {t} = this.props
        return [
            {type:'text', max: 20, name:'First_name',display:t('admin.hcp.form.first_name'), placeholder: t('admin.hcp.form.enter_first_name'), required:true, width:0.5, style:'inline'},
            {type:'text', max: 20, name:'Last_name',display:t('admin.hcp.form.last_name'), placeholder: t('admin.hcp.form.enter_last_name'), required:true, width:0.5, style:'inline'},
            {type:'dropdown', name:'Profession',display:t('admin.hcp.form.profession'), placeholder: t('admin.hcp.form.enter_profession'), required:true, width:0.5, style:'inline', options: ConstantsArrT(t,Constants.Profession)},
            {type:'text', max: 20, name:'MedicalLicense', placeholder: t('admin.hcp.form.enter_med_license'), display:t('admin.hcp.form.med_license'),required:false, width:0.5, style:'inline'},
            {type:'phone', name:'Phone_num1',  placeholder: t('admin.hcp.form.phone_number'), display:t('admin.hcp.form.phone_number'),required:true, width:0.5, style:'inline', isNumeric: true},
            {type:'text', max: 50, name:'Email',display:t('admin.hcp.form.email'), placeholder: t('admin.hcp.form.enter_email'), required:true, width:1, style:'inline'},
            {type:'searchableDropdown',max: 50, name:'Clinic_ID',display:t('admin.hcp.form.clinic'), placeholder: t('admin.hcp.form.select_clinic'), required:true, width:1, style:'block', options: []},
            {type:'checkbox', name:'isClinicAdmin',display: t('admin.hcp.form.is_admin'), width:1, style:'block', required:false},
            {type:'textarea', name:'Signature',display:t('admin.hcp.form.Signature'), placeholder: t('admin.hcp.form.Signature'), required:false, width:1, style:'block'}
        ]
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {errorsOnSave} = this.state
        let {t} = this.props

        return (
            <div className={"sidenav-complete"} style={{width:container_width, height:"100%"}}>
                <div className={"sidenav"} style={{width:width, height:"100%", float:'right'}}>
                    <SvGraphics onClick={this.closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'} height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'register-form-title container block'}>
                        <h3 className={'h-centered block'}>{this.props.title}</h3>
                    </div>
                    <div className={'register-form container block'}>
                        <SimpleFormBuilder
                            errors={errorsOnSave}
                            entry={this.state.entry}
                            matrix={this.state.matrix}
                            fields={this.getFields()}
                            clinics = {this.state.clinicOptions}
                            onEntryChange={e => this.onEntryChange(e)}
                            onEntryChangeByDropdown={(name,val) => this.onEntryChangeByDropdown(name,val)}
                        />
                    </div>
                </div>
                <div className={'register-form-nav-container block'}  >
                    <div className={'register-form-nav'}  style={{width:width,display:'flex',justifyContent:"space-around"}}>
                        <button type={"button"} onClick={this.saveInfo.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.save')}
                        </button>
                        <button type={"button"} onClick={this.closeSideBar.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.close')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
HcpEditForm.propTypes = {
    isSideBarOpen:Prototypes.bool.isRequired,
    editHCP:Prototypes.bool.isRequired,
    closeSideBar:Prototypes.func.isRequired,
    title: Prototypes.string.isRequired,
    entry: Prototypes.object,
}

export default HcpEditForm

